<div
  *ngIf="isActivated"
  class="card activated">
  <header>
    <h3 i18n>Account Geactiveerd</h3>
    <p i18n>Uw account is geactiveerd. U kan nu inloggen.</p>
  </header>
</div>
<app-card-login [isActivated]="isActivated"></app-card-login>
